import { DownloadType } from '../../../dto/enum/download-type.enum';
import { AbstractMediaUrlProvider } from './abstract-media-url.provider';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ReelUrlProvider extends AbstractMediaUrlProvider {
  public getType = (): DownloadType => DownloadType.REEL;
}
